import React from 'react';
import { AccordionCard } from './AccordionCard';

export interface DataFetchErrorProps {
  error: Error | null;
  technicalLogsLabel?: string;
  dataErrorLabel?: string;
}

function ErrorAccordionCard(technicalLogsLabel: string, errorElement: React.ReactElement): React.ReactElement {
  return (
    <AccordionCard
      renderHeader={() => <span>{technicalLogsLabel}</span>}
      collapsed={true}
      headerClassName={'py-0'}
      buttonClassName={'btn btn-flat-primary btn-md justify-content-start pl-0 ml-3'}
      ignoreDefaultButtonClassName={true}
      ignoreCardClassName={true}
    >
      {errorElement}
    </AccordionCard>
  );
}

export const DataFetchError: React.FC<DataFetchErrorProps> = ({
  error,
  technicalLogsLabel = 'Technical logs',
  dataErrorLabel = 'An error occurred while fetching data'
}) => {
  return (
    <>
      <p>{dataErrorLabel}</p>
      {error && (
        <>
          {ErrorAccordionCard(
            technicalLogsLabel,
            <p className="text-secondary pt-2" key={error.name + '_data'}>
              {error.message}
            </p>
          )}
        </>
      )}
    </>
  );
};
